import { useMemo } from 'react'

import { useStaticData } from '@mc/static-data-react'
import { usePromotion } from '@mc/promo-utils'
import { paths } from '@mc/paths'

import { i18nInstance } from '../i18n'
import { usePurchaseCtaCopyExperiment } from '../experiments/pen-4993_v1-global-purchase-cta-copy'

const tf = i18nInstance.getFixedT(null, '@mc/growth')

export const usePrimaryCta = () => {
  const { isPromotionOn: promoEnabled } = usePromotion()
  const { ctaNextPage } = useStaticData<{ ctaNextPage?: string }>()
  const { purchaseCopyKey: defaultPurchaseCopyKey } =
    usePurchaseCtaCopyExperiment()

  const cookieRedirectHref = useMemo(() => {
    try {
      return JSON.parse(ctaNextPage || 'null')
    } catch (e) {
      // parse error, pass
    }

    return null
  }, [ctaNextPage])

  // normally, CTA should redirect to class recommendations page

  // * Quiz Only Once *
  // “Sign Up CTA” →  (⭐Promo Page) → Quiz →  Quiz Results Page → Plans page
  // “Sign Up CTA” →  (⭐Promo Page) → Quiz →  Quiz Results Page → drop off → "Finish Sign Up CTA" → Quiz Results Page → Plans page
  // Hero Quiz → Quiz → Quiz Results Page → (⭐Promo Page) → Plans page
  // Hero Quiz → Quiz → Quiz Results Page → drop off → "Finish Sign Up CTA" → (⭐Promo Page) → Quiz Results Page → Plans page
  // Hero Quiz → Quiz → Quiz Results Page → (⭐Promo Page) → drop off → "Finish Sign Up CTA" → (⭐Promo Page) → Quiz Results Page → Plans page

  const ctaHref = useMemo(() => {
    if (cookieRedirectHref) {
      return cookieRedirectHref
    }

    if (!cookieRedirectHref && promoEnabled) {
      return paths.promotion
    }

    return paths.classRecommendations
  }, [cookieRedirectHref, promoEnabled])

  const userSeesSavedQuizFlow = !!cookieRedirectHref

  const ctaCopy = useMemo(() => {
    if (userSeesSavedQuizFlow) {
      // "Finish Sign Up" CTA for users with saved quiz state
      return tf('cta.finishSignup') as string
    }
    // default/control CTA copy
    return tf(defaultPurchaseCopyKey) as string
  }, [defaultPurchaseCopyKey, userSeesSavedQuizFlow])

  return {
    ctaCopy,
    ctaHref,
    userSeesSavedQuizFlow,
  }
}
